import { setLoginNameGA } from '_common/reactGa';
/**
 * 本地存储操作
 * Created by LiuHe on 2017/5/19.
 */

export default class Storage {
  /**
   * 保存key对应的本地数据
   * @param key
   * @param value
   */
  static set(key, value) {
    if (typeof value == 'object') {
      localStorage[key] = JSON.stringify(value);
    } else {
      localStorage[key] = value;
    }

    if (key === 'loginName') {
      setLoginNameGA();
    }
  }

  /**
   * 根据key获取对应的本地存储数据
   * @param key
   * @returns {object || null}
   */
  static get(key) {
    const value = localStorage[key];
    if (value) {
      return value;
    }
    return null;
  }

  /**
   * 移除指定key对应的值
   * @param key
   */
  static remove(key) {
    localStorage.removeItem(key);
  }
}
